/**
 * GENERADO por scratchpad/generar-orden-esenciales.cjs -- no editar a mano.
 * Fuente: WORK-MADERINCO-ARBOLES-COMPARTIDOS-v01_2026-10-19.json de Atenea (#30341), sha256 5a126fe02ba908d7cbeb47e8f2841c0734f871b1cdae703f257aea201dabe6f8
 * Orden de Atenea (#30340, Ares #30346): Cubierta -> Paredes -> Piso -> Agua y gas -> Electricidad.
 *
 * EL ORDEN ES UN DATO. Una seccion de la plantilla pertenece a una esencial si alguna de sus partidas tiene un id de
 * catalogo (fuenteId) que esta en los arboles de esa esencial; asi no se adivinan nombres ni claves.
 */
export const ESENCIALES_SHA256 = '5a126fe02ba908d7cbeb47e8f2841c0734f871b1cdae703f257aea201dabe6f8';
export const ESENCIALES = [
 {
  "id": "cubierta",
  "nombre": "Cubierta",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A12",
   "1342:PRESUPUESTO CASA:A13",
   "1342:PRESUPUESTO CASA:A14",
   "1342:PRESUPUESTO CASA:A15",
   "1342:PRESUPUESTO CASA:A16",
   "1346:PRESUPUESTO - 1C:B12",
   "1346:PRESUPUESTO - 1C:B13",
   "1346:PRESUPUESTO - 1C:B14",
   "1346:PRESUPUESTO - 1C:B15",
   "1346:PRESUPUESTO - 1C:B16",
   "1346:PRESUPUESTO - 1C:B17",
   "1346:PRESUPUESTO - 1D:B12",
   "1346:PRESUPUESTO - 1D:B13",
   "1346:PRESUPUESTO - 1D:B14",
   "1346:PRESUPUESTO - 1D:B15",
   "1346:PRESUPUESTO - 1D:B16",
   "1346:PRESUPUESTO - 1D:B17",
   "1346:PRESUPUESTO - 1D:B18",
   "1347:PRESUPUESTO CASA:A12",
   "1347:PRESUPUESTO CASA:A13",
   "1347:PRESUPUESTO CASA:A14",
   "1347:PRESUPUESTO CASA:A15",
   "4546:PRESUPUESTO CASA:A12",
   "4546:PRESUPUESTO CASA:A13",
   "4546:PRESUPUESTO CASA:A14",
   "4546:PRESUPUESTO CASA:A15",
   "4546:PRESUPUESTO CASA:A16",
   "4546:PRESUPUESTO CASA:A17",
   "APU:APU:B28",
   "APU:APU:B29",
   "APU:APU:B30",
   "APU:APU:B31",
   "APU:APU:B32",
   "APU:APU:B33",
   "APU:APU:B34"
  ]
 },
 {
  "id": "paredes",
  "nombre": "Paredes",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A19",
   "1342:PRESUPUESTO CASA:A20",
   "1342:PRESUPUESTO CASA:A21",
   "1342:PRESUPUESTO CASA:A22",
   "1342:PRESUPUESTO CASA:A23",
   "1342:PRESUPUESTO CASA:A24",
   "1342:PRESUPUESTO CASA:A25",
   "1342:PRESUPUESTO CASA:A26",
   "1342:PRESUPUESTO CASA:A27",
   "1346:PRESUPUESTO - 1C:B20",
   "1346:PRESUPUESTO - 1C:B21",
   "1346:PRESUPUESTO - 1C:B22",
   "1346:PRESUPUESTO - 1C:B23",
   "1346:PRESUPUESTO - 1C:B24",
   "1346:PRESUPUESTO - 1C:B25",
   "1346:PRESUPUESTO - 1C:B26",
   "1346:PRESUPUESTO - 1C:B27",
   "1346:PRESUPUESTO - 1C:B28",
   "1346:PRESUPUESTO - 1C:B29",
   "1346:PRESUPUESTO - 1C:B30",
   "1346:PRESUPUESTO - 1D:B21",
   "1346:PRESUPUESTO - 1D:B22",
   "1346:PRESUPUESTO - 1D:B23",
   "1346:PRESUPUESTO - 1D:B24",
   "1346:PRESUPUESTO - 1D:B25",
   "1346:PRESUPUESTO - 1D:B26",
   "1346:PRESUPUESTO - 1D:B27",
   "1346:PRESUPUESTO - 1D:B28",
   "1346:PRESUPUESTO - 1D:B29",
   "1346:PRESUPUESTO - 1D:B30",
   "1346:PRESUPUESTO - 1D:B31",
   "1347:PRESUPUESTO CASA:A18",
   "1347:PRESUPUESTO CASA:A19",
   "1347:PRESUPUESTO CASA:A20",
   "1347:PRESUPUESTO CASA:A21",
   "1347:PRESUPUESTO CASA:A22",
   "1347:PRESUPUESTO CASA:A23",
   "1347:PRESUPUESTO CASA:A24",
   "4546:PRESUPUESTO CASA:A20",
   "4546:PRESUPUESTO CASA:A21",
   "4546:PRESUPUESTO CASA:A22",
   "4546:PRESUPUESTO CASA:A23",
   "4546:PRESUPUESTO CASA:A24",
   "4546:PRESUPUESTO CASA:A25",
   "4546:PRESUPUESTO CASA:A26",
   "4546:PRESUPUESTO CASA:A27",
   "APU:APU:B10",
   "APU:APU:B14",
   "APU:APU:B15",
   "APU:APU:B16",
   "APU:APU:B17",
   "APU:APU:B18",
   "APU:APU:B19",
   "APU:APU:B20",
   "APU:APU:B21",
   "APU:APU:B22",
   "APU:APU:B23",
   "APU:APU:B24",
   "APU:APU:B5",
   "APU:APU:B6",
   "APU:APU:B7",
   "APU:APU:B8",
   "APU:APU:B9"
  ]
 },
 {
  "id": "piso",
  "nombre": "Piso",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A30",
   "1342:PRESUPUESTO CASA:A31",
   "1342:PRESUPUESTO CASA:A32",
   "1346:PRESUPUESTO - 1C:B46",
   "1346:PRESUPUESTO - 1C:B47",
   "1346:PRESUPUESTO - 1C:B48",
   "1346:PRESUPUESTO - 1C:B49",
   "1346:PRESUPUESTO - 1C:B50",
   "1346:PRESUPUESTO - 1D:B47",
   "1346:PRESUPUESTO - 1D:B48",
   "1346:PRESUPUESTO - 1D:B49",
   "1346:PRESUPUESTO - 1D:B50",
   "1346:PRESUPUESTO - 1D:B51",
   "1347:PRESUPUESTO CASA:A27",
   "1347:PRESUPUESTO CASA:A28",
   "1347:PRESUPUESTO CASA:A29",
   "1347:PRESUPUESTO CASA:A30",
   "4546:PRESUPUESTO CASA:A30",
   "4546:PRESUPUESTO CASA:A31",
   "4546:PRESUPUESTO CASA:A32",
   "4546:PRESUPUESTO CASA:A33",
   "4546:PRESUPUESTO CASA:A34",
   "4546:PRESUPUESTO CASA:A35",
   "4546:PRESUPUESTO CASA:A36",
   "4546:PRESUPUESTO CASA:A37",
   "4546:PRESUPUESTO CASA:A38",
   "4546:PRESUPUESTO CASA:A39",
   "4546:PRESUPUESTO CASA:A40",
   "4546:PRESUPUESTO CASA:A41",
   "APU:APU:F11",
   "APU:APU:F12",
   "APU:APU:F13",
   "APU:APU:F14",
   "APU:APU:F15",
   "APU:APU:F17",
   "APU:APU:F18",
   "APU:APU:F19",
   "APU:APU:F20",
   "APU:APU:F21",
   "APU:APU:F23",
   "APU:APU:F24",
   "APU:APU:F25",
   "APU:APU:F26",
   "APU:APU:F27",
   "APU:APU:F29",
   "APU:APU:F30",
   "APU:APU:F31",
   "APU:APU:F32",
   "APU:APU:F33",
   "APU:APU:F5",
   "APU:APU:F6",
   "APU:APU:F7",
   "APU:APU:F8",
   "APU:APU:F9"
  ]
 },
 {
  "id": "agua-gas",
  "nombre": "Agua y gas",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A35",
   "1342:PRESUPUESTO CASA:A36",
   "1342:PRESUPUESTO CASA:A37",
   "1346:PRESUPUESTO - 1C:B53",
   "1346:PRESUPUESTO - 1C:B54",
   "1346:PRESUPUESTO - 1D:B54",
   "1346:PRESUPUESTO - 1D:B55",
   "1347:PRESUPUESTO CASA:A33",
   "1347:PRESUPUESTO CASA:A34",
   "4546:PRESUPUESTO CASA:A44",
   "4546:PRESUPUESTO CASA:A45",
   "4546:PRESUPUESTO CASA:A46"
  ]
 },
 {
  "id": "electricidad",
  "nombre": "Electricidad",
  "fuenteIds": [
   "1342:PRESUPUESTO CASA:A40",
   "1342:PRESUPUESTO CASA:A41",
   "1346:PRESUPUESTO - 1C:B57",
   "1346:PRESUPUESTO - 1D:B58",
   "1347:PRESUPUESTO CASA:A37",
   "4546:PRESUPUESTO CASA:A49",
   "4546:PRESUPUESTO CASA:A50"
  ]
 }
];
